export const ROUTE = {
  ONBOARDING: "/onboarding",
  // Public routes
  SIGNIN: "/signin",
  LOGIN: "/login",
  SIGNUP: "/signup",
  SIGNUP_TYPE: "/signup/type",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  OAUTH_GOOGLE_RESULT: "/oauth/google/result",
  OAUTH_FACEBOOK_RESULT: "/oauth/facebook/result",
  QR: "/qr",
  QR_RETURN: "/r/:code",
  INVITE: "/invite/:code",
  ATTENDANCE_CHECKIN_ENTRY: "/attendance-checkin/entry",
  ONBOARDING_MEDIUM: "/onboarding/medium",
  ONBOARDING_TERREIRO: "/onboarding/terreiro",
  UPDATES: "/updates",
  UPDATE_DETAIL: "/updates/:slug",

  // Private routes
  APP_HOME: "/",
  NOTIFICATIONS: "/notifications",

  // Events
  EVENTS: "/events",
  EVENTS_NEW: "/events/new",
  EVENT: "/events/:id",
  EVENT_EDIT: "/events/:id/edit",
  EVENT_TICKETS: "/events/:id/tickets",
  INGRESSOS_NEW: "/ingressos/new",
  PUBLIC_TERREIRO: "/t/:slug",
  PUBLIC_EVENT: "/e/:slug",
  TICKET_VOUCHER: "/ingresso/:code",

  // Activities
  ACTIVITIES: "/activities",
  ACTIVITIES_NEW: "/activities/new",
  ACTIVITY: "/activities/:id",
  ACTIVITY_EDIT: "/activities/:id/edit",
  ACTIVITY_USE_MODEL: "/activities/:id/use-model",

  // Rituals (activities with type RITUAL)
  RITUALS: "/rituals",
  RITUALS_NEW: "/rituals/new",
  RITUAL: "/rituals/:id",
  RITUAL_EDIT: "/rituals/:id/edit",
  RITUAL_USE_MODEL: "/rituals/:id/use-model",

  // Profile / Medium
  PROFILE: "/profile",
  PROFILE_DATA: "/profile/data",
  PROFILE_MEDIUM_ROOT: "/profile/medium",
  PROFILE_MEDIUM: "/profile/medium/:id",
  PROFILE_MEDIUM_DATA: "/profile/medium/:id/data",
  PROFILE_ADDRESS: "/profile/address",
  PROFILE_ADDRESS_WITH_ID: "/profile/address/:id",
  PROFILE_CONTACTS: "/profile/contacts",
  PROFILE_CREDENTIALS: "/profile/credentials",
  PROFILE_PASSKEYS: "/profile/passkeys",
  SPIRITUAL_PROFILE: "/spiritual-profile",
  SPIRITUAL_PROFILE_NEW: "/spiritual-profile/new",

  // Mediums
  MEDIUMS: "/mediums",
  MEDIUMS_LIST: "/mediums/list",
  MEDIUMS_ATTENDANCE: "/mediums/attendance",
  MEDIUMS_RANKS: "/mediums/ranks",
  MEDIUMS_LINES: "/mediums/lines",
  MEDIUMS_NEW: "/mediums/new",
  MEDIUM: "/mediums/:id",
  ATTENDANCE_INSIGHTS: "/attendance-insights",
  SUPPLY_PLAN: "/supply-plan",

  // Inventory
  INVENTORY: "/inventory",
  INVENTORY_LIST: "/inventory/list",
  INVENTORY_SUPPLY: "/inventory/supply",
  INVENTORY_CATEGORIES: "/inventory/categories",
  INVENTORY_VIEW: "/inventory/:id",
  INVENTORY_EDIT: "/inventory/:id/edit",
  INVENTORY_NEW: "/inventory/new",

  // Terreiro
  TERREIRO: "/terreiro",
  TERREIRO_SEARCH: "/terreiros/buscar",
  TERREIRO_JOIN: "/terreiro/join",
  TERREIRO_PROFILE: "/terreiro/:id/profile",
  TERREIRO_ADDRESS: "/terreiro/:id/address",
  TERREIRO_CONTACT: "/terreiro/:id/contact",
  TERREIRO_MEDIUM_VIEW: "/terreiro/:terreiroId/medium/:mediumId",

  // Financial
  FINANCIAL: "/financial",
  FINANCIAL_ACCOUNTS: "/financial/accounts",
  FINANCIAL_NEW: "/financial/new",
  FINANCIAL_ACCOUNT: "/financial/account/:id",
  FINANCIAL_MONTHLY_FEE: "/financial/monthly-fee",
  FINANCIAL_MONTHLY_FEE_EDIT: "/financial/monthly-fee/:id/edit",
  FINANCIAL_MONTHLY_FEE_PAYMENTS: "/financial/monthly-fee/payments",
  FINANCIAL_INCOME: "/financial/income",
  FINANCIAL_INCOME_EDIT: "/financial/income/:id/edit",
  FINANCIAL_OUTCOME: "/financial/outcome",
  FINANCIAL_OUTCOME_EDIT: "/financial/outcome/:id/edit",
  FINANCIAL_TRANSPARENCY: "/financial/transparency",

  // Transactions
  TRANSACTIONS_NEW: "/transactions/new",

  // Settings & Not found
  SETTINGS: "/settings",
  SETTINGS_MEETINGS: "/settings/meetings",
  SETTINGS_USAGE: "/settings/usage",
  SETTINGS_PLAN: "/settings/plan",
  SETTINGS_NOTIFICATIONS: "/settings/notifications",
  SETTINGS_PRIVACY_POLICY: "/settings/privacy-policy",
  AFFILIATE_PROGRAM: "/settings/affiliate",
  ROLE_MANAGEMENT: "/settings/roles",
  ROLE_CREATE: "/settings/roles/new",
  ROLE_EDIT: "/settings/roles/:roleId/edit",
  MY_PERMISSIONS: "/settings/my-permissions",

  // Subscriptions
  SUBSCRIPTION_SUCCESSFUL: "/subscription/successful",
  SUBSCRIPTION_CANCELATION: "/subscription/cancelation",
  SUBSCRIPTION_REQUIRED: "/subscription/required",

  // Ritual Baths
  RITUAL_BATHS: "/ritual-baths",
  RITUAL_BATHS_NEW: "/ritual-baths/new",
  RITUAL_BATH: "/ritual-baths/:id",
  RITUAL_BATH_EDIT: "/ritual-baths/:id/edit",
  RITUAL_BATH_SCHEDULE: "/ritual-baths/:id/schedule",
  RITUAL_BATH_CATEGORIES: "/ritual-baths/categories",

  // Gamification
  LEADERBOARD: "/leaderboard",
  BADGES: "/badges",
  GAMIFICATION_HELP: "/gamification/how-it-works",
  ACADEMY: "/academy",
  ACADEMY_MODULE: "/academy/modules/:moduleId",

  // Social network
  SOCIAL: "/social",
  SOCIAL_ONBOARDING: "/social/onboarding",
  SOCIAL_EXPERIENCES_NEW: "/social/experiences/new",
  SOCIAL_EXPERIENCE: "/social/experiences/:id",
  SOCIAL_QUESTIONS: "/social/questions",
  SOCIAL_QUESTION_NEW: "/social/questions/new",
  SOCIAL_QUESTION: "/social/questions/:id",
  SOCIAL_SIMILAR: "/social/similar",
  SOCIAL_PROFILE: "/social/u/:username",
  SOCIAL_PROFILE_ME: "/social/profile/me",
  SOCIAL_PROFILE_EDIT: "/social/profile/edit",
  SOCIAL_CONNECTIONS: "/social/connections",
  SOCIAL_CONNECTIONS_USER: "/social/u/:username/connections",
  SOCIAL_DISCOVER: "/social/discover",
  SOCIAL_SAVED: "/social/saved",
  SOCIAL_NOTIFICATIONS: "/social/notifications",
  SOCIAL_PRIVACY: "/social/privacy",
  SOCIAL_MESSAGES: "/social/messages",
  SOCIAL_CONVERSATION: "/social/messages/:conversationId",

  // Examples & Demo
  MOON_EXAMPLE: "/moon-example",

  NOT_FOUND: "*",
} as const;

// helper type for route values (optional)
export type RouteValue = (typeof ROUTE)[keyof typeof ROUTE];
